import toast from 'react-hot-toast';
import {
    FETCH_OFFERING_ERROR,
    FETCH_OFFERING_REQUEST,
    GET_OFFERINGS,
    GET_SELECTED_OFFERING,
    GET_SELECTED_OFFERING_PARTNER,
    IS_OFFERING_PARTNER_SELECTED,
    IS_OFFERING_SELECTED,
} from '../ActionTypes';

const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getOffering = (partnerId, offeringId) => async () => {
        try {
            var response = await axiosCall.get(
                `offerings/partner/${partnerId}/${offeringId}`
            );
            return response.data;
        } catch (err) {
            console.error(err);
        }
    };

    const getOfferings = (offerings) => {
        return {
            type: GET_OFFERINGS,
            payload: offerings,
        };
    };

    const fetchOfferingRequest = () => {
        return {
            type: FETCH_OFFERING_REQUEST,
        };
    };

    const offeringError = (error) => {
        return {
            type: FETCH_OFFERING_ERROR,
            payload: error,
        };
    };

    const getSelectedOfferingPartner = (partner) => {
        return {
            type: GET_SELECTED_OFFERING_PARTNER,
            payload: partner,
        };
    };

    const getSelectedOffering = (offering) => {
        return {
            type: GET_SELECTED_OFFERING,
            payload: offering,
        };
    };

    const setIsOfferingPartnerSelected = (status) => {
        return {
            type: IS_OFFERING_PARTNER_SELECTED,
            payload: status,
        };
    };

    const setIsOfferingSelected = (status) => {
        return {
            type: IS_OFFERING_SELECTED,
            payload: status,
        };
    };

    const fetchOfferings = (partner) => {
        return async (dispatch) => {
            try {
                dispatch(fetchOfferingRequest);
                var response = await axiosCall.get(
                    `/offerings/partner/` + partner.id
                );
                const partnerOfferings = response.data;
                dispatch(getOfferings(partnerOfferings));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(offeringError(errorMsg));
            }
        };
    };

    const getAllOfferings = () => async () =>
        axiosCall.get('offerings/partners');

    const fetchAllOfferings = () => {
        return async (dispatch) => {
            try {
                dispatch(fetchOfferingRequest);
                var response = await axiosCall.get(`offerings/partners`);
                const partnerOfferings = response.data.data;
                dispatch(getOfferings(partnerOfferings));
            } catch (error) {
                const errorMsg = error.message;
                dispatch(offeringError(errorMsg));
            }
        };
    };

    const storeNewPracticeOffering = (practiceId, newOfferingId) => {
        return async (dispatch) => {
            try {
                dispatch(fetchOfferingRequest);
                await axiosCall.post(
                    `practices/${practiceId}/relations`,
                    newOfferingId
                );
            } catch (error) {
                const errorMsg = error.message;
                dispatch(offeringError(errorMsg));
            }
        };
    };

    const fetchBitwerxOfferings = () => {
        return async (dispatch) => {
            try {
                dispatch(fetchOfferingRequest);
                var response = await axiosCall.get(`/offerings/bitwerx`);
                const bitwerxOfferings = response.data.items;
                dispatch(getOfferings(bitwerxOfferings));
                return bitwerxOfferings;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(offeringError(errorMsg));
            }
        };
    };

    const fetchBitwerxOffering = (bitwerxOfferingId) => {
        return async (dispatch) => {
            try {
                dispatch(fetchOfferingRequest);
                if(!bitwerxOfferingId){
                    dispatch(offeringError('no offering id found'));
                    toast(
                        () => (
                            <div className="text-light d-flex justify-content-between w-100">
                                Error: Something went wrong fetching the Bitwerx Offering
                            </div>
                        ),
                        {
                            duration: 7500,
                            style: {
                                minWidth: '25vw',
                                background: 'red',
                            },
                        }
                    );
                }
                var response = await axiosCall.get(
                    `/offerings/bitwerx/${bitwerxOfferingId}`
                );
                const bitwerxOffering = response.data.data;
                return bitwerxOffering;
            } catch (error) {
                const errorMsg = error.message;
                dispatch(offeringError(errorMsg));
            }
        };
    };

    const createBitwerxOffering = (bitwerxOffering) => {
        return async (dispatch) => {
            let res;
            try {
                res = await axiosCall.post(`offerings/bitwerx/`, {
                    ...bitwerxOffering,
                });
            } catch (err) {
                let error;
                if (err.response?.data) {
                    error = JSON.stringify(err.response.data, null, 4);
                } else if (err.request?.data) {
                    error = JSON.stringify(err.request.data, null, 4);
                } else error = JSON.stringify(err, null, 4);

                const errorMsg = error;
                dispatch(offeringError(errorMsg));

                toast(
                    () => (
                        <div className="text-light d-flex justify-content-between w-100">
                            Error: {error}
                        </div>
                    ),
                    {
                        duration: 7500,
                        style: {
                            minWidth: '25vw',
                            background: 'red',
                        },
                    }
                );
            }
            return res?.data;
        };
    };

    const updateBitwerxOffering = (bitwerxOfferingId, bitwerxOffering) => {
        return async (dispatch) => {
            let res;
            try {
                if(!bitwerxOfferingId){
                    dispatch(offeringError('no offering id found'));
                    toast(
                        () => (
                            <div className="text-light d-flex justify-content-between w-100">
                                Error: Something went wrong updating the Bitwerx Offering
                            </div>
                        ),
                        {
                            duration: 7500,
                            style: {
                                minWidth: '25vw',
                                background: 'red',
                            },
                        }
                    );
                }
                res = await axiosCall.patch(`offerings/bitwerx/${bitwerxOfferingId}`, {
                    ...bitwerxOffering,
                });
            } catch (err) {
                let error;
                if (err.response?.data) {
                    error = JSON.stringify(err.response.data, null, 4);
                } else if (err.request?.data) {
                    error = JSON.stringify(err.request.data, null, 4);
                } else error = JSON.stringify(err, null, 4);

                const errorMsg = error;
                dispatch(offeringError(errorMsg));

                toast(
                    () => (
                        <div className="text-light d-flex justify-content-between w-100">
                            Error: {error}
                        </div>
                    ),
                    {
                        duration: 7500,
                        style: {
                            minWidth: '25vw',
                            background: 'red',
                        },
                    }
                );
            }
            return res?.data;
        };
    };

    const deleteBitwerxOffering = (bitwerxOfferingId) => {
        return async (dispatch) => {
            let res;
            try {
                if(!bitwerxOfferingId){
                    dispatch(offeringError('no offering id found'));
                    toast(
                        () => (
                            <div className="text-light d-flex justify-content-between w-100">
                                Error: Something went wrong deleting Bitwerx Offering
                            </div>
                        ),
                        {
                            duration: 7500,
                            style: {
                                minWidth: '25vw',
                                background: 'red',
                            },
                        }
                    );
                }
                res = await axiosCall.delete(`offerings/bitwerx/${bitwerxOfferingId}`);
            } catch (err) {
                let error;
                if (err.response?.data) {
                    error = JSON.stringify(err.response.data, null, 4);
                } else if (err.request?.data) {
                    error = JSON.stringify(err.request.data, null, 4);
                } else error = JSON.stringify(err, null, 4);

                const errorMsg = error;
                dispatch(offeringError(errorMsg));

                toast(
                    () => (
                        <div className="text-light d-flex justify-content-between w-100">
                            Error: {error}
                        </div>
                    ),
                    {
                        duration: 7500,
                        style: {
                            minWidth: '25vw',
                            background: 'red',
                        },
                    }
                );
                throw error;
            }
            return res?.data;
        };
    };

    const deleteBitwerxSubOffering = (bitwerxSubOfferingId) => {
        return async (dispatch) => {
            let res;
            try {
                if(!bitwerxSubOfferingId){
                    dispatch(offeringError('no sub offering id found'));
                    toast(
                        () => (
                            <div className="text-light d-flex justify-content-between w-100">
                                Error: Something went wrong deleting Sub Offering
                            </div>
                        ),
                        {
                            duration: 7500,
                            style: {
                                minWidth: '25vw',
                                background: 'red',
                            },
                        }
                    );
                }
                res = await axiosCall.delete(`offerings/bitwerx/suboffering/${bitwerxSubOfferingId}`);
            } catch (err) {
                let error;
                if (err.response?.data) {
                    error = JSON.stringify(err.response.data, null, 4);
                } else if (err.request?.data) {
                    error = JSON.stringify(err.request.data, null, 4);
                } else error = JSON.stringify(err, null, 4);

                const errorMsg = error;
                dispatch(offeringError(errorMsg));

                toast(
                    () => (
                        <div className="text-light d-flex justify-content-between w-100">
                            Error: {error}
                        </div>
                    ),
                    {
                        duration: 7500,
                        style: {
                            minWidth: '25vw',
                            background: 'red',
                        },
                    }
                );
                throw error;
            }
            return res?.data;
        };
    };

    const createOffering =
        (partnerId, payload = {}) =>
        async () =>
            axiosCall.post('offerings/partner/' + partnerId, { ...payload });

    const updateOffering =
        (partnerId, payload = {}) =>
        async () =>
            axiosCall.patch('offerings/partner/' + partnerId, { ...payload });

    return {
        createOffering,
        fetchAllOfferings,
        fetchBitwerxOfferings,
        fetchBitwerxOffering,
        createBitwerxOffering,
        updateBitwerxOffering,
        deleteBitwerxOffering,
        deleteBitwerxSubOffering,
        fetchOfferingRequest,
        fetchOfferings,
        getAllOfferings,
        getOffering,
        getOfferings,
        getSelectedOffering,
        getSelectedOfferingPartner,
        offeringError,
        setIsOfferingPartnerSelected,
        setIsOfferingSelected,
        storeNewPracticeOffering,
        updateOffering,
    };
};

export default initActions;
